import apiClient from "../helper/Axios/axiosHelper";
import logger from "../utils/logger";


export class FormationService {


    static async createFormation(data) {

        let response = await apiClient.post("Formation", data);

        logger.debug('createFormation response: ', response)

        return response;
    }

    
    static async getFormations(data, param) {

        logger.info('getMember params: ', data, ' ', param)
        const members = await apiClient.get(`${param}`, param && {
            params: data,
            headers: {
                Accept: "application/json"
            }

        })

        logger.warn('members: ', members)

        return members
    }

    static async getFormationById(id) {
        try {
            let response = await apiClient.get(`Formation/${id}`);

            logger.debug('getFormationById response: ', response)

            return response.data;

        } catch (error) {
            logger.error('error al obtener la  formacion: ', error)
        }
    }


    static async executeMemberAction(actionType, member, FormationId) {

        switch (actionType.apiKey) {

            // case  'pay':
            //     return apiClient.post(`Formation/${FormationId}/${member.id}/pay`)

            case 'delete':
                return apiClient.post(`Formation/${FormationId}/removeMember/${member.id}`)

            case 'add':
                return apiClient.post(`Formation/${FormationId}/addMember/${member.id}`)

            default:
                logger.error(`Acción no soportada: ${actionType}`)
        }
    }


    static async editFormation(id, data) {

        logger.debug('edit data controler es: ', data)

        try {
            let response = await apiClient.put(`Formation/${id}`, data);

            logger.warn('edit formation response: ', response)

            return response;

        } catch (error) {
            logger.error('error al editar la  formacion: ', error)
        }


    }

    static async getProfessors(data,) {

        logger.info('getMember params: ', data)
        const members = await apiClient.get("Formation/Professors", {
            params: data,
            headers: {
                Accept: "application/json"
            }

        })

        logger.warn('members: ', members)

        return members
    }
}